import { fulfillmentApi } from '../../../api/fulfillmentApi';
import { AppDispatch, RootState } from '../../store';
import { getBatchTrackingNumber } from '../batches';
import { startLoadingWorkOrder, stopLoadingWorkOrder } from './workOrderSlice';

export const putWorkOrderTrackingNumber = (WorkOrderId: number, trackingNumber: string, id: number) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingWorkOrder());
        await fulfillmentApi.put(`workOrder?id=${WorkOrderId}&trackingNumber=${trackingNumber}`)
            .then(async function (response) {
                const workOrder = response.data;

                dispatch(getBatchTrackingNumber(+id));

            }).catch(function (error) {
                dispatch(stopLoadingWorkOrder());
            });

    }
}
